import React, { PropsWithChildren } from 'react';
import { Box, SxProps, Typography, useTheme } from '@mui/material';

export type InfoCardOrderProps = {
    label: string;
    sx?: SxProps;
    onClick?: () => void;
};

const InfoCardOrder: React.FunctionComponent<PropsWithChildren<InfoCardOrderProps>> = function ({
    label,
    sx = {},
    children,
    onClick,
}) {
    const { palette } = useTheme();

    const labelSx = {
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '19.2px',
        color: palette.grey[500],
    };

    return (
        <Box
            sx={{ ...sx, ...(typeof onclick !== 'undefined' && { cursor: 'pointer' }) }}
            onClick={onClick}
        >
            <Typography
                component="span"
                sx={labelSx}
            >
                {label}
            </Typography>
            <Box
                sx={{ minHeight: '48px', display: 'flex', alignItems: 'center', padding: '8px 0' }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default InfoCardOrder;
